import { Doctor } from "types";
import { getDoctorImage, replaceWithAmpersand } from "helpers";

const transformDoctor = (data: any): Doctor => {
  const {
    id,
    givenName,
    familyName,
    displayName,
    photo,
    yearsExperience,
    price,
    specialisations,
    isMwellPlus,
  } = data;

  return {
    id,
    firstName: givenName,
    lastName: familyName,
    displayName,
    image: photo && getDoctorImage(id, photo),
    experience: yearsExperience,
    price,
    specialties: specialisations,
    specialtiesJoined: replaceWithAmpersand(specialisations.join(", ")),
    isPremium: isMwellPlus,
  };
};

export { transformDoctor };
